import { Stack, Tooltip, Typography } from '@mui/material';
import { AccountState, type Account } from '@repo/api-gw-sdk';
import semver from 'semver';

import { isAccountRoleMajorMinorVersionOld } from '@/utils/roles';

import { Icon } from '../shared/icon';

export const EonRoleVersion = ({ account }: { account: Account }) => {
  if (account.state === AccountState.ACCOUNT_STATE_INSUFFICIENT_PERMISSIONS) {
    return <Typography>--</Typography>;
  }

  const showWarning = isAccountRoleMajorMinorVersionOld(account);

  return (
    <Stack direction='row' alignItems='center' gap='12px'>
      <Typography className={'inline-block'}>
        {'installedVersion' in account && semver.valid(account.installedVersion)
          ? account.installedVersion
          : '1.0.0'}
      </Typography>
      {showWarning && (
        <Tooltip title='Update available'>
          <Icon
            iconClass={
              'material-symbols-error-outline-rounded h-[20px] w-[20px]'
            }
          />
        </Tooltip>
      )}
    </Stack>
  );
};
